import { StandardEvents } from '@shopify/events';

/**
 * Calm "added" feedback (Gina, Oct 9): the cart no longer opens by itself.
 * A small toast slides up for a few seconds: "Added to cart ★  View cart".
 */
const STAR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false"><path d="M12 3.6l2.5 5.2 5.7.8-4.1 4 1 5.7L12 16.6l-5.1 2.7 1-5.7-4.1-4 5.7-.8z" fill="#C8922C" stroke="#C8922C" stroke-width="2.2" stroke-linejoin="round"/></svg>';
let toast;
let hideTimer;

function ensureToast() {
  if (toast) return toast;
  toast = document.createElement('div');
  toast.className = 'lk-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML =
    '<span class="lk-toast__text">Added to cart <span class="lk-star" aria-hidden="true">' + STAR + '</span></span>' +
    '<button type="button" class="lk-toast__view">View cart</button>';
  toast.querySelector('.lk-toast__view').addEventListener('click', () => {
    hide();
    const cartLink = document.querySelector('header-actions .action__cart');
    if (cartLink) cartLink.click();
    else window.location.href = '/cart';
  });
  document.body.appendChild(toast);
  return toast;
}

function hide() {
  if (toast) toast.classList.remove('lk-toast--visible');
}

function show() {
  const el = ensureToast();
  requestAnimationFrame(() => el.classList.add('lk-toast--visible'));
  clearTimeout(hideTimer);
  hideTimer = setTimeout(hide, 4500);
}

/*
 * Oct 21 (Gina, audit M-02): on a product page the confirmation sits right under the
 * Add to cart button the shopper tapped: "✓ Added to your cart · View cart →".
 * Oct 21 (T-454, report 5.5): the confirmation REPLACES the button for a few seconds,
 * then the button comes back.
 * Other "+ Add" buttons (cards, cart suggestions) keep the toast.
 */
let lastAddButton = null;
document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest('button, [role="button"]') : null;
    if (button) lastAddButton = button;
    // T-454: the shop takes 2 to 3 s to answer an add; show it is working right away.
    if (button && button.closest('add-to-cart-component') && !button.disabled) {
      button.classList.add('lk-adding');
      button.setAttribute('aria-busy', 'true');
      setTimeout(() => clearAdding(button), 10000);
    }
  },
  true
);

function clearAdding(button) {
  if (!button) return;
  button.classList.remove('lk-adding');
  button.removeAttribute('aria-busy');
}

let noteTimer;
function showNoteUnder(button) {
  const block = button.closest('.buy-buttons-block') || button.closest('product-form-component') || button.parentElement;
  if (!block) return false;
  let note = document.querySelector('.lk-added-note');
  if (!note) {
    note = document.createElement('div');
    note.className = 'lk-added-note';
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');
    note.innerHTML = '<span>✓ Added to your cart</span><a href="/cart" class="lk-added-note__link">View cart →</a>';
  }
  block.after(note);
  note.hidden = false;
  block.style.display = 'none';
  clearTimeout(noteTimer);
  noteTimer = setTimeout(() => {
    note.hidden = true;
    block.style.display = '';
  }, 5000);
  return true;
}

/*
 * Oct 21 (Gina, T-454): "+ Add" on the cart page must show the item without a reload.
 * The theme re-renders the cart itself; this is only a safety net: if the page still
 * shows "Your cart is empty" (or the count is stale) after a successful add, reload once.
 */
function cartPageSafetyNet(itemCount) {
  if (!itemCount || !/^\/cart\/?$/.test(window.location.pathname)) return;
  setTimeout(() => {
    const stillEmpty = document.querySelector('.cart-page--empty');
    const bubble = document.querySelector('cart-icon [ref="cartBubbleCount"]');
    const bubbleStale = bubble && parseInt(bubble.textContent || '0', 10) !== itemCount;
    if (stillEmpty || bubbleStale) window.location.reload();
  }, 1500);
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;
  const button = lastAddButton;
  event.promise?.finally(() => clearAdding(button)).catch(() => {});
  event.promise
    ?.then(({ cart, detail } = {}) => {
      if (detail?.didError) return;
      cartPageSafetyNet(cart?.totalQuantity ?? detail?.itemCount ?? 0);
      const drawer = document.querySelector('theme-drawer#cart-drawer, #cart-drawer');
      if (drawer && drawer.hasAttribute('open')) return;
      const onProductPage = button && button.closest('.product-information__grid, sticky-add-to-cart');
      if (onProductPage && !button.closest('sticky-add-to-cart') && showNoteUnder(button)) return;
      show();
    })
    .catch(() => {});
});
